import {ActivatedRoute, Router} from '@angular/router';
import {CommonDataService} from '../../shared/services/common-data.service';
import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ConfirmationService, Message} from 'primeng/primeng';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import {SettingsService} from '../../settings/settings.service';
import {SessionService} from '../../shared/services/session.service';
import {ControlContainer, FormGroup} from '@angular/forms';
import {CampaignService} from '../campaign.service';

@Component({
    selector: 'app-order-form',
    templateUrl: './order-form.component.html',
    styleUrls: ['./order-form.component.css']
})
export class OrderFormComponent implements OnInit {

    @Input() noBanner: boolean;
    @Input() finalForm: boolean;
    @Input() nonProfit: boolean;
    @Input() orders: any [] = [];
    msg: Message[];
    currentUser: any;
    formGroup: FormGroup;

    orderDTO: any = {
        'campaignId': null,
        'qtyForms': null,
        'qtyMemberships': null,
        'requestBanner': null,
        'specialInstructions': null,
        'checkOrganizationAddress': null,
        'shipToContact': null,
        'shipToAddress': null,
        'shipToCity': null,
        'shipToState': null,
        'shipToZipcode': null
    };

    constructor(private slimLoadingBarService: SlimLoadingBarService,
                private settingsService: SettingsService,
                private campaignService: CampaignService,
                private confirmationService: ConfirmationService,
                private router: Router,
                private route: ActivatedRoute,
                private commonDataService: CommonDataService,
                private sessionService: SessionService,
                private _parentContainer: ControlContainer,
                private cdr: ChangeDetectorRef) {

        // this.createOrder = new FormGroup({
        //     'campaign': new FormControl('', Validators.required),
        //     'qtyForms': new FormControl('', Validators.required),
        //     'requestBanner': new FormControl(''),
        //     'specialInstructions': new FormControl(''),
        //     'shipToContact': new FormControl('', Validators.required),
        //     'shipToAddress': new FormControl('', Validators.required),
        //     'shipToCity': new FormControl('', Validators.required),
        //     'shipToState': new FormControl('', Validators.required),
        //     'shipToZipcode': new FormControl('', Validators.required),
        // });
    }

    ngOnInit(): void {
        this.settingsService.currentUser().subscribe(user => {
            this.currentUser = user;
        }, error => {
            console.log('Error get current user');
        });

        this.formGroup = this._parentContainer.control as FormGroup;
    }

    prefillShippingAddress() {
        if (this.formGroup.value.shipToAddress === '' && this.orders.length ) {
            this.formGroup.get('shipToContact').setValue(this.orders[0].shipToContact);
            this.formGroup.get('shipToAddress').setValue(this.orders[0].shipToAddress);
            this.formGroup.get('shipToCity').setValue(this.orders[0].shipToCity);
            this.formGroup.get('shipToState').setValue(this.orders[0].shipToState);
            this.formGroup.get('shipToZipcode').setValue(this.orders[0].shipToZipcode);
        }
    }

    toggleCheckbox() {
        this.formGroup.get('checkPrizeCards').setValue(
            this.formGroup.value.qtyPrizeCards > 0);
        this.formGroup.get('checkDebitCards').setValue(
            this.formGroup.value.qtyGiftCard20 +
            this.formGroup.value.qtyGiftCard50 +
            this.formGroup.value.qtyGiftCard100 > 0);
        this.formGroup.get('checkTeacherFreeMembership').setValue(
            this.formGroup.value.qtyTeacherFreeMembership > 0);
    }


    formatZip(value) {
        if (value === undefined) {
            return '';
        }
        value = value.toString().replace(/[^0-9]/g, '');
        if (value.length > 9) {
            value = value.slice(0, 9);
        }
        if (value.length > 5) {
            value = value.slice(0, 5) + '-' + value.slice(5);
        }

        return value;
    };

    formatZipCode(event) {
        const keycode = event.keyCode;
        const isTextInputKey =
            (keycode > 47 && keycode < 58) || // number keys
            keycode === 32 || keycode === 8 || // spacebar or backspace
            (keycode > 64 && keycode < 91) || // letter keys
            (keycode > 95 && keycode < 112) || // numpad keys
            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
            (keycode > 218 && keycode < 223);   // [\]' (in order)
        if (isTextInputKey) {
            if (!event.currentTarget.value || event.currentTarget.value == 0) {
                return;
            }
            event.currentTarget.value = this.formatZip(event.currentTarget.value);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/order-form/order-form.component.ts